require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./newyearwithwinpe.json") })
        }
      }, "path---newyearwithwinpe");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---newyearwithwinpe!./.cache/json/newyearwithwinpe.json
// module id = 1179
// module chunks = 231608221292675